<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
    <v-overlay :value="!dataReady">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- บริษัท -->
              <v-select
                v-model="Company"
                :items="CompanyItem"
                dense
                outlined
                @change="getDataBranch(Company)"
                hide-details
                label="บริษัท"
                class="ma-2"
              ></v-select>
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                hide-details
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                outlined
                hide-details
                label="แผนก"
                class="ma-2"
              ></v-select>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- ส่วนงาน -->
              <v-select
                v-model="Segment"
                :items="SegmentItem"
                dense
                outlined
                @change="getDataSegment(Segment)"
                hide-details
                label="ส่วนงาน"
                class="ma-2"
              ></v-select>
              <!-- กลุ่มงาน -->
              <v-select
                v-model="Group"
                :items="GroupItem"
                @change="getDataGroup(Group)"
                dense
                outlined
                hide-details
                label="กลุ่มงาน"
                class="ma-2"
              ></v-select>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- วัน -->
              <!-- <v-select
                v-model="day"
                :items="dayName"
                dense
                outlined
                hide-details
                label="วัน"
                class="ma-2"
              ></v-select> -->
              <!-- เดือน -->
              <!-- <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select> -->
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-icon
                color="#871B12"
                size="30"
                @click="getDataToday()"
                >mdi-calendar-search</v-icon
              >
              <v-icon
                color="#871B12"
                size="30"
                @click="clear()"
                >mdi-refresh</v-icon
              >
            </v-sheet>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-btn
              :loading="loading3"
              :disabled="loading3"
              color="blue-grey"
              class="ma-2 white--text"
              @click="(loader = 'loading3'), exportReportDaily()"
            >
              รายงานสรุป
              <v-icon right dark> mdi-cloud-download </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="searchAll2"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-text>
                   <v-data-table
                      :headers="columns"
                      :items="dataItem"
                      :search="searchAll2"
                      :items-per-page="20"
                    >
                    <!-- <template v-slot:[`item.point_total`]="{ item }">
                   {{item.sum_late + item.sum_absent + item.sum_adjustStatusIN + item.sum_adjustStatusOUT + item.sum_leaveSick + item.sum_leaveBusiness + item.sum_leaveUnpaid + item.sum_diligent}}
                  </template>
                    <template v-slot:[`item.point_net`]="{ item }">
                      120
                  </template> -->
                  <!-- <template slot="body.append">
                    <tr>
                        <th>Total</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th>33%</th>
                    </tr>
                  </template> -->
                    </v-data-table>
              </v-card-text>
              <v-card-text>
                <v-data-table
                  :headers="columns1"
                  :search="searchAll2"
                  :items="dataItem1"
                  :items-per-page="20"
                ></v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment' // แปลง date
import dayName from '../../../assets/master/Date/day.json'
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    moment
  },
  data () {
    return {
      PK: '',
      center: {},
      session: this.$session.getAll(),
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'คะแนนรวม',
          disabled: false,
          href: '/HRM/EmpPerformance/PerformanceIndicator'
        }
      ],
      dialog: false,
      dataReady: true,
      dateTime: '', // Generate DateTime
      searchAll2: '',
      loader: null,
      loading3: false,
      date: new Date().toISOString().substr(0, 10),
      // Data Table Config
      columns1: [
        { text: 'รหัสพนักงาน', value: 'empCode', width: '120' },
        { text: 'ชื่อ - นามสกุล', value: 'empFull_NameTH', width: '150' },
        { text: 'แผนก', value: 'masDepartmentName', width: '150' },
        { text: 'สาขา', value: 'masBranchName', width: '150' },
        { text: 'บริษัท', value: 'masCompanyName', width: '150' },
        { text: 'ส่วนงาน', value: 'masSegmentName', width: '150' },
        { text: 'กลุ่มงาน', value: 'masGroupName', width: '150' },
        { text: 'เดือน8', value: 'month8', width: '100' },
        { text: 'เดือน9', value: 'month9', width: '100' },
        { text: 'เดือน10', value: 'month10', width: '100' },
        { text: 'เดือน11', value: 'month11', width: '100' },
        { text: 'เดือน12', value: 'month12', width: '100' },
        { text: 'เดือน1', value: 'month1', width: '100' },
        { text: 'เดือน2', value: 'month2', width: '100' },
        { text: 'เดือน3', value: 'month3', width: '100' },
        { text: 'เดือน4', value: 'month4', width: '100' },
        { text: 'เดือน5', value: 'month5', width: '100' },
        { text: 'เดือน6', value: 'month6', width: '100' },
        { text: 'เดือน7', value: 'month7', width: '100' },
        { text: 'Q1', value: 'q1', width: '100' },
        { text: 'Q2', value: 'q2', width: '100' },
        { text: 'Q3', value: 'q3', width: '100' },
        { text: 'Q4', value: 'q4', width: '100' },
        { text: 'ครึ่งปีแรก', value: 'halfํYear1', width: '100' },
        { text: 'ครึ่งปีหลัง', value: 'halfํYear2', width: '100' },
        { text: '1 ปี', value: 'fullYear', width: '100' }
      ],
      columns: [
        { text: 'รหัสพนักงาน', value: 'empCode', width: '120' },
        { text: 'ชื่อ - นามสกุล', value: 'empFull_NameTH', width: '150' },
        { text: 'แผนก', value: 'masDepartmentName', width: '150' },
        { text: 'สาขา', value: 'masBranchName', width: '150' },
        { text: 'บริษัท', value: 'masCompanyName', width: '150' },
        { text: 'ส่วนงาน', value: 'masSegmentName', width: '150' },
        { text: 'กลุ่มงาน', value: 'masGroupName', width: '150' },
        { text: 'เดือน', value: 'shiftMonth', width: '100' },
        { text: 'Normal', value: 'Normal', width: '100' },
        { text: 'Actual', value: 'Actual', width: '100' },
        { text: 'Late', value: 'Late', width: '100' },
        { text: 'Early', value: 'Early', width: '100' },
        { text: 'AFL', value: 'AFL', width: '100' },
        { text: 'OT Total', value: 'OTHours', width: '100' },
        { text: 'OT(1)', value: 'OTHours1', width: '100' },
        { text: 'OT(1.5)', value: 'OTHours15', width: '100' },
        { text: 'NoIn', value: 'absent2', width: '100' },
        { text: 'NoOut', value: 'absent1', width: '100' },
        { text: 'ลาป่วย', value: 'leaveSick', width: '100' },
        { text: 'ลากิจ', value: 'leaveBusiness', width: '100' },
        { text: 'ลาพักร้อน', value: 'leaveHoliday', width: '100' },
        { text: 'ลาอุปสมบท', value: 'leaveOrdination', width: '100' },
        { text: 'ลาคลอด', value: 'leaveMaternity', width: '100' },
        { text: 'ลาไม่รับค่าตอบแทน', value: 'leaveUnpaid', width: '100' },
        { text: 'point', width: '150' },
        { text: 'point of Late', value: 'sum_late', width: '150' },
        { text: 'point of Absent', value: 'sum_absent', width: '150' },
        { text: 'point of NoIN', value: 'sum_adjustStatusIN', width: '150' },
        { text: 'point of NoOut', value: 'sum_adjustStatusOUT', width: '150' },
        { text: 'point of ป่วย', value: 'sum_leaveSick', width: '150' },
        { text: 'point of ลากิจ', value: 'sum_leaveBusiness', width: '150' },
        { text: 'point of ลาไม่รับค่าตอบแทน', value: 'sum_leaveUnpaid', width: '150' },
        { text: 'point of หักเบี้ยขยัน 100%', value: 'sum_diligent', width: '150' },
        { text: 'point total', value: 'pointTotal1', width: '150' },
        { text: 'Net', value: 'sumPointTotal1', width: '150' },
        { text: 'ความเสียหาย', width: '150' },
        { text: 'จำนวน', value: 'count_asset', width: '150' },
        { text: 'point ความเสียหาย', value: 'point_asset', width: '150' },
        // { text: 'point', value: 'ass', width: '150' },
        { text: 'ตักเตือน', width: '150' },
        { text: 'จำนวน', value: 'count_chasten', width: '150' },
        { text: 'point ตักเตือน', value: 'point_chasten', width: '150' },
        // { text: 'point', value: 'ass', width: '150' },
        { text: 'อบรม', value: 'point_educate', width: '150' },
        { text: 'point total', value: 'pointTotal2', width: '150' },
        // { text: 'Net', value: 'pointTotal2', width: '150' },
        { text: 'รวม', value: 'sumPoint120', width: '150' }
      ],
      dataItem: [],
      dataItem1: [],
      export_data: [],
      export_data_by_month: [],
      dataByEmp: [],
      dataByEmpView: [],
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // บริษัท
      Department: '', // บริษัท
      Group: '',
      Segment: '',
      GroupItem: [],
      SegmentItem: [],
      disableBranch: true,
      disableDeparment: true,
      disableSearch: false,
      year: '',
      month: '',
      day: '',
      disableYear: true,
      disableMonth: true,
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber
    }
  },
  async mounted () {
    // console.log(this.mobileCheck())
    await this.getGetToken()
    this.dataReady = false

    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()

    await this.getDataCompany()
    await this.getDataBranch()
    await this.getDataDepartment()

    await this.getDataSegment()
    await this.getDataGroup()

    await this.getDataToday()
    await this.getDataToday1()
  },
  methods: {
    mobileCheck () {
      let check = false;
      // eslint-disable-next-line
      (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera)
      return check
    },
    toggleShowEmpList (empFullName) {
      this.dataItem.forEach(dessert => {
        if (dessert.empFull_NameTH === empFullName) {
          dessert.hide = !dessert.hide
        }
      })
    },
    async clear () {
      console.log('clear')
      this.Company = ''
      this.Branch = ''
      this.Department = ''
      await this.getDataToday()
    },
    async getDataToday () {
      this.dataReady = false
      this.dataItem = []

      var Company = (this.Company === '' ? '' : '&masCompanyName=' + this.Company)
      var Branch = (this.Branch === '' ? '' : '&masBranchName=' + this.Branch)
      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)

      var Segment = (this.Segment === '' ? '' : '&masSegmentName=' + this.Segment)
      var Group = (this.Group === '' ? '' : '&masGroupName=' + this.Group)

      console.log('shiftYear=' + this.year)

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/reportYear?shiftYear=' + this.year + Company + Branch + Department + Segment + Group
        )
        .then(async (response) => {
          this.dataReady = true
          let rs = response.data
          let dataSelect = []
          if (rs.status !== false) {
            for (let i = 0; i < rs.length; i++) {
              let t = rs[i]
              t.empId = t.empCode + t.shiftMonth + t.shiftYear
              t.pointTotal1 = t.sum_late + t.sum_absent + t.sum_adjustStatusIN + t.sum_adjustStatusOUT + t.sum_leaveSick + t.sum_leaveBusiness + t.sum_leaveUnpaid + t.sum_diligent
              t.sumPointTotal1 = 60 - t.pointTotal1
              t.point_chasten = 20
              t.point_asset = 30
              t.point_educate = 10
              t.pointTotal2 = 60
              t.sumPointTotal2 = 60
              t.sumPoint120 = t.sumPointTotal1 + t.sumPointTotal2
              t.hide = true
              dataSelect.push(t)
            }
            this.dataItem = dataSelect
            console.log('dataSelectUse', dataSelect)
          } else {
            this.dataItem = []
          }
          console.log('dataItem', this.dataItem)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
      // await this.charJSCovid()
    },
    async getDataToday1 () {
      this.dataReady = false
      this.dataItem1 = []

      var Company = (this.Company === '' ? '' : '&masCompanyName=' + this.Company)
      var Branch = (this.Branch === '' ? '' : '&masBranchName=' + this.Branch)
      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)

      var Segment = (this.Segment === '' ? '' : '&masSegmentName=' + this.Segment)
      var Group = (this.Group === '' ? '' : '&masGroupName=' + this.Group)

      console.log('shiftYear=' + this.year)

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/reportYear?shiftYear=' + this.year + Company + Branch + Department + Segment + Group
        )
        .then(async (response) => {
          this.dataReady = true
          let rs = response.data
          let dataSelect = []
          let dataSelectUse = []
          if (rs.status !== false) {
            for (let i = 0; i < rs.length; i++) {
              let d = rs[i]
              if (dataSelect.filter(el => { return el.empCode === d.empCode }).length === 0) {
                d.month8 = 120
                d.month9 = 120
                d.month10 = 120
                d.month11 = 120
                d.month12 = 120
                d.month1 = 120
                d.month2 = 120
                d.month3 = 120
                d.month4 = 120
                d.month5 = 120
                d.month6 = 120
                d.month7 = 120
                dataSelect.push(d)
              }
            }
            for (let i = 0; i < dataSelect.length; i++) {
              let d = dataSelect[i]
              let checkEmp = rs.filter(el => { return el.empCode === d.empCode })
              if (checkEmp.length > 0) {
                for (let x = 0; x < checkEmp.length; x++) {
                  let t = checkEmp[x]
                  let pointTotalCheck = t.sum_late + t.sum_absent + t.sum_adjustStatusIN + t.sum_adjustStatusOUT + t.sum_leaveSick + t.sum_leaveBusiness + t.sum_leaveUnpaid + t.sum_diligent
                  let pointTotal = Math.ceil(pointTotalCheck)
                  if (t.shiftMonth === '8') {
                    d.month8 = d.month8 - pointTotal
                  } else if (t.shiftMonth === '9') {
                    d.month9 = d.month9 - pointTotal
                  } else if (t.shiftMonth === '10') {
                    d.month10 = d.month10 - pointTotal
                  } else if (t.shiftMonth === '11') {
                    d.month11 = d.month11 - pointTotal
                  } else if (t.shiftMonth === '12') {
                    d.month12 = d.month12 - pointTotal
                  } else if (t.shiftMonth === '1') {
                    d.month1 = d.month1 - pointTotal
                  } else if (t.shiftMonth === '2') {
                    d.month2 = d.month2 - pointTotal
                  } else if (t.shiftMonth === '3') {
                    d.month3 = d.month3 - pointTotal
                  } else if (t.shiftMonth === '4') {
                    d.month4 = d.month4 - pointTotal
                  } else if (t.shiftMonth === '5') {
                    d.month5 = d.month5 - pointTotal
                  } else if (t.shiftMonth === '6') {
                    d.month6 = d.month6 - pointTotal
                  } else if (t.shiftMonth === '7') {
                    d.month7 = d.month7 - pointTotal
                  }
                }
                d.q1 = Math.ceil((d.month8 + d.month9 + d.month10) / 3)
                d.q2 = Math.ceil((d.month11 + d.month12 + d.month1) / 3)
                d.q3 = Math.ceil((d.month2 + d.month3 + d.month4) / 3)
                d.q4 = Math.ceil((d.month5 + d.month6 + d.month7) / 3)
                d.halfํYear1 = Math.ceil((d.month8 + d.month9 + d.month10 + d.month11 + d.month12 + d.month1) / 6)
                d.halfํYear2 = Math.ceil((d.month2 + d.month3 + d.month4 + d.month5 + d.month6 + d.month7) / 6)
                d.fullYear = Math.ceil((d.month8 + d.month9 + d.month10 + d.month11 + d.month12 + d.month1 + d.month2 + d.month3 + d.month4 + d.month5 + d.month6 + d.month7) / 12)
                dataSelectUse.push(d)
              }
            }
            this.dataItem1 = dataSelectUse
            console.log('dataSelectUse', dataSelectUse)
          } else {
            this.dataItem1 = []
          }
          console.log('dataItem', this.dataItem1)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
      // await this.charJSCovid()
    },
    async exportReportDaily () {
      this.dataReady = false
      var Company = (this.Company === '' ? '' : '&masCompanyName=' + this.Company)
      var Branch = (this.Branch === '' ? '' : '&masBranchName=' + this.Branch)
      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/getOderEmp?shiftDay=' +
            this.day + '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' + this.year + Company + Branch + Department
        )
        .then(async (response) => {
          this.dataReady = true
          var tem = []
          response.data.forEach((element) => {
            // console.log(element)
            let s = {
              'รหัสพนักงาน': element.empCode,
              'ชื่อพนักงาน': element.empFull_NameTH,
              'แผนก': element.masDepartmentName,
              'สาขา': element.masBranchName,
              'บริษัท': element.masCompanyName,
              'ปี': element.shiftYear,
              'เดือน': element.shiftMonth,
              'วัน': element.shiftDay,
              'วันเดือนปี': element.shiftDay + '/' + element.shiftMonth + '/' + element.shiftYear,
              'รหัสกะ': element.masShiftTypeCode,
              'กะเข้างาน': element.masShiftTypeStartTime,
              'กะเวลาออกงาน': element.masShiftTypeEndTime,
              'สถานที่ทำงาน': element.location === null ? 'ไม่พบข้อมูล' : element.location,
              'เวลาเข้างาน': element.checkInStartStamp,
              'ระยะทางเข้างาน(KM)': element.checkInDistance,
              'เวลาออกงาน': element.checkInEndStamp,
              'ระยะทางออกงาน(KM)': element.checkOutDistance,
              'สถานะสาย': element.lateStatus === null ? 'ไม่พบข้อมูล' : element.lateStatus,
              'สาย(นาที)': element.lateTime === null ? 'ไม่พบข้อมูล' : element.lateTime,
              'สถานะออกก่อน': element.earlyStatus === null ? 'ไม่พบข้อมูล' : element.earlyStatus,
              'ออกก่อน(นาที)': element.earlyTime === null ? 'ไม่พบข้อมูล' : element.earlyTime,
              'Adjust': element.adjustStatus === null ? 'ไม่พบข้อมูล' : element.adjustStatus,
              'Adjust Remark': element.adjustRemark === null ? 'ไม่พบข้อมูล' : element.adjustRemark,
              'Adjust Header Remark': element.adjustRemarkHeader === null ? 'ไม่พบข้อมูล' : element.adjustRemarkHeader,
              'ระดับสีประเมินความเสี่ยง': element.color === null ? 'ไม่พบข้อมูล' : element.color,
              'ลา': element.leave === null ? 'ไม่พบข้อมูล' : element.leave,
              'location-in': element.checkInMapUrl === null ? 'ไม่พบข้อมูล' : element.checkInMapUrl,
              'location-out': element.checkOutMapUrl === null ? 'ไม่พบข้อมูล' : element.checkOutMapUrl,
              'โอที(นาที)': element.OT_MINUTE,
              'โอที(ชั่วโมง)': element.OT_HOURS,
              '1 เท่า': element.OTHOLIDAY,
              '1.5 เท่า': element.OTWORK
            }
            tem.push(s)
          })
          tem = tem
            .sort((a, b) => a.รหัสพนักงาน - b.รหัสพนักงาน || a.ปี - b.เดือน || a.วัน - b.วัน)
          var info = XLSX.utils.json_to_sheet(tem)
          var wb = XLSX.utils.book_new() // make Workbook of Excel
          XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
          XLSX.writeFile(wb, 'CheckInOut-Report(' + this.day + '-' + this.month + '-' + this.year + ').xls') // name of the file is 'book.xlsx'
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log(error)
        })
    },
    async exportReportMonth () {
      this.dataReady = false
      var Company = (this.Company === '' ? '' : '&masCompanyName=' + this.Company)
      var Branch = (this.Branch === '' ? '' : '&masBranchName=' + this.Branch)
      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/getOderEmp?shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' + this.year + Company + Branch + Department
        )
        .then(async (response) => {
          this.dataReady = true
          var tem = []
          response.data.forEach((element) => {
            // console.log(element)
            let s = {
              'รหัสพนักงาน': element.empCode,
              'ชื่อพนักงาน': element.empFull_NameTH,
              'แผนก': element.masDepartmentName,
              'สาขา': element.masBranchName,
              'บริษัท': element.masCompanyName,
              'ปี': element.shiftYear,
              'เดือน': element.shiftMonth,
              'วัน': element.shiftDay,
              'วันเดือนปี': element.shiftDay + '/' + element.shiftMonth + '/' + element.shiftYear,
              'รหัสกะ': element.masShiftTypeCode,
              'กะเข้างาน': element.masShiftTypeStartTime,
              'กะเวลาออกงาน': element.masShiftTypeEndTime,
              'สถานที่ทำงาน': element.location === null ? 'ไม่พบข้อมูล' : element.location,
              'เวลาเข้างาน': element.checkInStartStamp,
              'ระยะทางเข้างาน(KM)': element.checkInDistance,
              'เวลาออกงาน': element.checkInEndStamp,
              'ระยะทางออกงาน(KM)': element.checkOutDistance,
              'สถานะสาย': element.lateStatus === null ? 'ไม่พบข้อมูล' : element.lateStatus,
              'สาย(นาที)': element.lateTime === null ? 'ไม่พบข้อมูล' : element.lateTime,
              'สถานะออกก่อน': element.earlyStatus === null ? 'ไม่พบข้อมูล' : element.earlyStatus,
              'ออกก่อน(นาที)': element.earlyTime === null ? 'ไม่พบข้อมูล' : element.earlyTime,
              'Adjust': element.adjustStatus === null ? 'ไม่พบข้อมูล' : element.adjustStatus,
              'Adjust Remark': element.adjustRemark === null ? 'ไม่พบข้อมูล' : element.adjustRemark,
              'Adjust Header Remark': element.adjustRemarkHeader === null ? 'ไม่พบข้อมูล' : element.adjustRemarkHeader,
              'ระดับสีประเมินความเสี่ยง': element.color === null ? 'ไม่พบข้อมูล' : element.color,
              'ลา': element.leave === null ? 'ไม่พบข้อมูล' : element.leave,
              'location-in': element.checkInMapUrl === null ? 'ไม่พบข้อมูล' : element.checkInMapUrl,
              'location-out': element.checkOutMapUrl === null ? 'ไม่พบข้อมูล' : element.checkOutMapUrl,
              'โอที(นาที)': element.OT_MINUTE,
              'โอที(ชั่วโมง)': element.OT_HOURS,
              '1 เท่า': element.OTHOLIDAY,
              '1.5 เท่า': element.OTWORK
            }
            tem.push(s)
          })
          tem = tem
            .sort((a, b) => a.รหัสพนักงาน - b.รหัสพนักงาน || a.ปี - b.เดือน || a.วัน - b.วัน)
          var info = XLSX.utils.json_to_sheet(tem)
          var wb = XLSX.utils.book_new() // make Workbook of Excel
          XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
          XLSX.writeFile(wb, 'CheckInOut-Report-Month(' + this.month + '-' + this.year + ').xls') // name of the file is 'book.xlsx'
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log(error)
        })
    },
    async exportReportMonthSummary () {
      this.export_data_by_month = []
      // this.dataReady = false
      var Company = (this.Company === '' ? '' : '&masCompanyName=' + this.Company)
      var Branch = (this.Branch === '' ? '' : '&masBranchName=' + this.Branch)
      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/reportMonth?shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' + this.year + Company + Branch + Department
        )
        .then(async (response) => {
          if (response.data.length) {
            // this.dataReady = true
            console.log(response.data)
            var tem = []

            response.data.forEach((element) => {
              let s = {
                'รหัสพนักงาน': element.empCode,
                'ชื่อพนักงาน': element.empFull_NameTH,
                'แผนก': element.masDepartmentName,
                'สาขา': element.masBranchName,
                'บริษัท': element.masCompanyName,
                'เดือน': this.month,
                'ปี': this.year,
                'Normal วัน/ด': element.Normal,
                'Actual เข้า/ด': element.Actual,
                'AFL': element.AFL,
                'Late นาที/ด': element.Late,
                'Early นาที/ด': element.Early,
                'No Check IN วัน': element.absent2,
                'No Check OUT วัน': element.absent1,
                'Adjust No IN': element.adjustStatusIN,
                'Adjust No OUT': element.adjustStatusOUT,
                'ลาป่วย': element.leaveSick,
                'ลากิจ': element.leaveBusiness,
                'ลาพักร้อน': element.leaveHoliday,
                'ลาอุปสมบท': element.leaveOrdination,
                'ลาคลอด': element.leaveMaternity,
                'ลาไม่รับค่าตอบแทน': element.leaveUnpaid,
                'รวมลา': element.totalLeave,
                'โอทีรวม/นาที': element.OTMinutes,
                'โอทีรวม/ชม': element.OTHours,
                'โอที 1.0': element.OTHours1,
                'โอที 1.5': element.OTHours15,
                'สลับกะ': element.TranferTotal,
                'หักเบี้ยขยัน': element.diligentAllowance,
                'หักขาดงาน 2 เท่า': element.absentFromWork,
                'หักขาดงาน 1 เท่า': element.leaveUnpaid,
                'หักpoint': element.point
                // 'รวมลา': element.leaveSick + element.leaveMaternity + element.leaveBusiness + element.leaveHoliday + element.leaveOrdination
              }
              tem.push(s)
            })
            var info = XLSX.utils.json_to_sheet(tem)
            var wb = XLSX.utils.book_new() // make Workbook of Excel
            XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
            XLSX.writeFile(wb, 'CheckInOut-Report-Month-Summary(' + this.month + '-' + this.year + ').xls') // name of the file is 'book.xlsx'
          } else {
            console.log('ไม่เจอข้อมูลนะ')
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log(error)
        })
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_company/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('Company', response.data)
          this.dataReady = true
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.text = d.masCompanyName
              s.value = d.masCompanyName
              d = s
              this.CompanyItem.push(d)
            }
          } else {
            this.CompanyItem = []
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('Company', response.data)
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.text = d.masBranchName
              s.value = d.masBranchName
              d = s
              this.BranchItem.push(d)
            }
          } else {
            this.BranchItem = []
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('getDataDepartment : ', this.DepartmentItem)
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.text = d.masDepartmentName
              s.value = d.masDepartmentName
              d = s
              this.DepartmentItem.push(d)
            }
          } else {
            this.DepartmentItem = []
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // กลุ่ม
    async getDataGroup () {
      this.GroupItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_group/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('getDataGroupItem : ', this.GroupItem)
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.text = d.masGroupName
              s.value = d.masGroupName
              d = s
              this.GroupItem.push(d)
            }
          } else {
            this.GroupItem = []
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // ส่วนงาน
    async getDataSegment () {
      this.SegmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_segment/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('getDataSegment : ', this.SegmentItem)
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.text = d.masSegmentName
              s.value = d.masSegmentName
              d = s
              this.SegmentItem.push(d)
            }
          } else {
            this.SegmentItem = []
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
.Color-Font {
  color: #808588;
}
.Color-Font-Action {
  color: #b61c1c;
}
.Color-Font-Preview {
  color: #262a34;
}
.Color-Button {
  color: #b61c1c;
}
.Divider {
  border: 2px solid #808588;
  background: #808588;
  border-radius: 5px;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/EmpPerformance/PerformanceIndicator.vue